'use strict';module.exports={};